import { useEffect, useState } from "react"
import SmallPopup from "../../../components/SmallPopup"
import Popup from "../../../components/Popup"
import Input from "../../../components/Input"

export default function ShippingPopup({onClose,edit=false,onSubmit,orderInfo,submitting})
{
    const [manageData, setManageData] = useState({ id: edit, shippingProducts: [] });
    const [category, setCategory] = useState([]);
    const [hsn, setHsn] = useState([]);
    const [showCrop, setShowCrop] = useState(false);
    const formName = 'updateShipping';

    useEffect(() => {
        if (orderInfo && orderInfo.shippingProducts) {
            const updatedShippingProducts = orderInfo.shippingProducts.map(item => ({
                id: item.id,
                productName: item.product.name,
                productId: item.product.id,
                shippingOrderId: item.shippingOrderId,
                shippedQuantity: item.shippedQuantity,
                shippedCartons: item.shippedCartons,
                quantity: item.quantity,
                cartons: item.cartons,
                totalProducts: item.totalProducts,
                shippingCartons: item.shippingCartons || '',
                unitType: item.unitType || 'cartons',
            }));
            setManageData(prevData => ({ ...prevData, shippingProducts: updatedShippingProducts }));
        }
    }, [orderInfo]);

    const updateShippingQuantity = (index, value) => {
        setManageData(prevData => {
            const updatedShippingProducts = [...prevData.shippingProducts];
            updatedShippingProducts[index].shippingCartons = value;
            return { ...prevData, shippingProducts: updatedShippingProducts };
        });
    };

    const updateUnitType = (index, value) => {
        setManageData(prevData => {
            const updatedShippingProducts = [...prevData.shippingProducts];
            updatedShippingProducts[index].unitType = value;
            return { ...prevData, shippingProducts: updatedShippingProducts };
        });
    };
    return (
        <Popup title={'Update Shipping'} submitTitle={'Submit'} submitting={submitting} onClose={onClose} formName={formName}>
            <form name={formName} onSubmit={(e) => onSubmit(e, manageData)} id={formName} className='w-full'>
                <div className="grid grid-cols-12 mb-1 ">
                    <div className="items-center px-2 col-span-4">
                        <p className="text-xs text-[#959595] font-medium">Product Name</p>
                    </div>
                    <div className="px-2 items-center col-span-3">
                        <p className="text-xs text-[#959595] font-medium">Total Units</p>
                    </div>
                    <div className="w-full col-span-5">
                        <p className="text-xs text-[#959595] font-medium">Enter Units</p>
                    </div>
                </div>
                {manageData.shippingProducts.map((item, index) => {
                    return <div className="grid grid-cols-12 border border-gray-200 rounded-md mb-4 items-center bg-[#fafafa]" key={index}>
                        <div className="py-2 items-center px-2 col-span-4">
                            <p className="text-xs font-medium">{item.productName}</p>
                        </div>
                        <div className="border-l border-gray-300 py-2 px-2 items-center col-span-3">
                            <p className="text-xs font-medium">{item.cartons} ({item.quantity} Qty)</p>
                        </div>
                        <div className="border-l border-gray-300 w-full col-span-5 flex">
                            <select className="w-full py-2 px-2 border-0 rounded-none border-r bg-transparent" value={item.unitType} onChange={(e)=>updateUnitType(index,e.target.value)}>
                                <option value="cartons">Cartons</option>
                                <option value="quantity">Quantity</option>
                            </select>
                            <input type="text" 
                            className="w-full py-2 px-2 rounded-md bg-transparent"
                                value={item.shippingCartons}
                                onChange={(e) => updateShippingQuantity(index, e.target.value)}
                            />
                        </div>
                    </div>
})}
            </form>
        </Popup>
    );
}